export type ReportFieldColumn = {
  key: string;
  value: string;
  locked?: boolean;
  minWidth?: number;
  align?: string;
};

export const ADJUSTED_COST_PRICE_COLUMN: ReportFieldColumn = {
  key: "adjustedCostPrice",
  value: "Adj. Cost",
  minWidth: 112,
};

const CURRENT_VALUE_COLUMN_KEYS = new Set([
  "currentValue",
  "currentAmount",
  "currentVal",
  "marketValue",
]);

/** Insert Adj. Cost immediately after Current Value (unrealized holding reports). */
export const appendAdjustedCostPriceColumn = <T extends ReportFieldColumn>(
  columns: T[],
): T[] => {
  if (!Array.isArray(columns) || columns.length === 0) return columns;
  if (columns.some((col) => col.key === "adjustedCostPrice")) return columns;

  const idx = columns.findIndex((col) =>
    CURRENT_VALUE_COLUMN_KEYS.has(col.key),
  );
  const insertAt = idx >= 0 ? idx + 1 : columns.length;

  return [
    ...columns.slice(0, insertAt),
    ADJUSTED_COST_PRICE_COLUMN as T,
    ...columns.slice(insertAt),
  ];
};
